import React from "react";
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';

/**
 * ActionButton
 *
 * A reusable button wrapper that displays any React node (typically an icon)
 * with a Material-UI Tooltip on hover.
 * 
 */

const ActionButton = ({ children, className, tooltip, onClick }) => {
  return (
    <Tooltip title={tooltip} arrow>
      <div className={className} onClick={onClick}>
        {children}
      </div>
    </Tooltip>
  );
};

ActionButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default ActionButton;
